import React from 'react';
import { Hero } from '../components/Hero';
import { WhyPay } from '../components/WhyPay';
import { BenefitCards } from '../components/BenefitCards';
import { HowItWorks } from '../components/HowItWorks';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { ContactSection } from '../components/ContactSection';
export function Home() {
  return <>
      <Hero data-id="element-437" data-mp="1zih1hqxkj9bt" />
      {/* Answer "why pay if it's free?" right away — establishes the value
          before the visitor sees the price. */}
      <WhyPay data-id="element-438" data-mp="24hk7bdldhjku" />
      <Pricing data-id="element-439" data-mp="24j4siclsrq61" />
      <BenefitCards data-id="element-440" data-mp="29g4y6meqiqwm" />
      <HowItWorks data-id="element-441" data-mp="29flsq569tuzh" />
      <FAQ data-id="element-442" data-mp="29f26wddi2mg6" />
      <ContactSection data-id="element-443" data-mp="29fbww0yjotlv" />
    </>;
}